import { Alert, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import useDataGridStore from "stores/dataGridStore";

const BannerWrapper = styled.div`
  margin-bottom: 8px;
`;

interface RefreshNotificationBannerProps {
  onRefresh?: () => void;
}

export const RefreshNotificationBanner: React.FC<RefreshNotificationBannerProps> = ({ 
  onRefresh 
}) => {
  const { showCategoryRefreshBanner, setShowCategoryRefreshBanner } = useDataGridStore();

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    }
    setShowCategoryRefreshBanner(false);
  };

  const handleDismiss = () => {
    setShowCategoryRefreshBanner(false);
  };

  if (!showCategoryRefreshBanner) return null;

  return (
    <BannerWrapper>
      <Alert
        message="Du har startat en operation som kör i bakgrunden"
        description="När notifikationen om att jobbet är färdigt dyker upp så ladda om för att se ändringarna."
        type="info"
        icon={<ReloadOutlined />}
        showIcon={true}
        action={
          <Button size="middle" type="primary" onClick={handleRefresh}>
            Ladda om
          </Button>
        }
        onClose={handleDismiss}
      />
    </BannerWrapper>
  );
};

